import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import Firearms from './pages/Firearms';
import Components from './pages/Components';
import Purchases from './pages/Purchases';
import Recipes from './pages/Recipes';
import RecipePrint from './pages/RecipePrint';
import Loads from './pages/Loads';
import FiringSessions from './pages/FiringSessions';
import Analytics from './pages/Analytics';
import Login from './pages/Login';
import Admin from './pages/Admin';
import Profile from './pages/Profile';
import UsersDirectory from './pages/UsersDirectory';
import Messages from './pages/Messages';
import { initializeAPI } from './services/api';
import './index.css';

function RequireAuth({ children }) {
  const location = useLocation();
  let authed = false;
  let mustChange = false;
  try {
    authed = !!localStorage.getItem('authToken');
    mustChange = JSON.parse(localStorage.getItem('authUser') || '{}')?.must_change_password === true;
  } catch {}
  if (!authed && location.pathname !== '/login') {
    return <Navigate to="/login" replace />;
  }
  if (authed && mustChange && location.pathname !== '/profile') {
    return <Navigate to="/profile" replace />;
  }
  return children;
}

function AdminOnly({ children }) {
  let isAdmin = false;
  try { isAdmin = JSON.parse(localStorage.getItem('authUser') || '{}')?.is_admin === true; } catch {}
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
}

function App() {
  useEffect(() => {
    // Initialize default data only if not authenticated (for development convenience)
    let authed = false;
    try { authed = !!localStorage.getItem('authToken'); } catch {}
    if (!authed) {
      initializeAPI.defaultData()
        .then(() => {
          console.log('Default data initialized');
        })
        .catch((error) => {
          console.error('Error initializing default data:', error);
        });
    }
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/profile" element={<RequireAuth><Profile /></RequireAuth>} />
            <Route path="/" element={<RequireAuth><Dashboard /></RequireAuth>} />
            <Route path="/firearms" element={<RequireAuth><Firearms /></RequireAuth>} />
            <Route path="/components" element={<RequireAuth><Components /></RequireAuth>} />
            <Route path="/purchases" element={<RequireAuth><Purchases /></RequireAuth>} />
            <Route path="/recipes" element={<RequireAuth><Recipes /></RequireAuth>} />
            <Route path="/recipes/print/:id" element={<RequireAuth><RecipePrint /></RequireAuth>} />
            <Route path="/loads" element={<RequireAuth><Loads /></RequireAuth>} />
            <Route path="/firing-sessions" element={<RequireAuth><FiringSessions /></RequireAuth>} />
            <Route path="/analytics" element={<RequireAuth><Analytics /></RequireAuth>} />
            <Route path="/admin" element={<RequireAuth><AdminOnly><Admin /></AdminOnly></RequireAuth>} />
            <Route path="/users" element={<RequireAuth><UsersDirectory /></RequireAuth>} />
            <Route path="/messages" element={<RequireAuth><Messages /></RequireAuth>} />
          </Routes>
        </main>
        <Toaster position="top-right" />
      </div>
    </Router>
  );
}

export default App;